import { graphql, useStaticQuery } from "gatsby";
import { ServiceIndexIntroductionQuery } from "./query.generated";

export type CMSIntroductionData = ServiceIndexIntroductionQuery["cms"];

export function useStaticIntroductionQuery(): CMSIntroductionData {
  const data = useStaticQuery<ServiceIndexIntroductionQuery>(
    graphql`
      query ServiceIndexIntroduction {
        cms {
          site(hostname: "www.italymondo.com") {
            serviceIndexPage: pages(
              contentType: "italymondo_services.IMServiceIndexPage"
            ) {
              ... on CMS_IMServiceIndexPage {
                introMedia {
                  ... on CMS_MediaImagesBlock {
                    __typename
                    images {
                      image {
                        alt
                        url
                        urlSharp {
                          childImageSharp {
                            gatsbyImageData(placeholder: BLURRED, width: 900)
                          }
                        }
                      }
                    }
                  }
                  ... on CMS_TestimonialsBlock {
                    __typename
                    testimonials {
                      testimonial {
                        date
                        longMessage
                        name
                        photo {
                          alt
                          url
                          urlSharp {
                            childImageSharp {
                              gatsbyImageData(
                                height: 60
                                width: 60
                                placeholder: BLURRED
                              )
                            }
                          }
                        }
                        sourceDetail {
                          logo {
                            title
                            url
                          }
                          url
                        }
                      }
                    }
                  }
                }
                introMediaPlacement
                introParagraph
                introShadowHeader
              }
            }
          }
        }
      }
    `
  );
  return data.cms;
}
